import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { PlayFolder, Syncable } from '../../types';
import { useStore } from '@nanostores/react';
import {
  $playFolderModalIsOpen,
  $playFolders,
  $playFolderSelectModalIsOpen,
  $playFoldersIsLoading,
  getFolders,
} from '../../store/playFolders';
import { Modal } from 'antd';
import { lighterBlueBackground, yellow } from '../colors';
import { Button } from '../../ui/Button';
import { XMarkIcon, FolderIcon, QueueListIcon } from '@heroicons/react/24/outline';

type SelectFolderModalProps = {
  onSelect: (data: PlayFolder) => void
  onlySelect?: boolean
}

export const SelectFolderModal: FC<SelectFolderModalProps> = ({ onSelect, onlySelect = false }) => {
  const modalStore = useStore($playFolderSelectModalIsOpen)

  const [isOpen, setIsOpen] = useState<boolean>(false)

  useEffect(() => {
    setIsOpen(modalStore)
  }, [modalStore]);

  if (!isOpen) return null
  return <SelectFolderModalContent onSelect={onSelect} onlySelect={onlySelect} />
}

const SelectFolderModalContent: FC<SelectFolderModalProps> = ({ onSelect, onlySelect = false }) => {
  const foldersStore = useStore($playFolders)
  const [currentFolders, setCurrentFolders] = useState<Syncable<PlayFolder>[]>([])
  const [isFoldersLoading, setFoldersLoading] = useState<boolean>(true)
  const foldersIsLoadingStore = useStore($playFoldersIsLoading)
  // const { data: folders, isLoading: isFoldersLoading } = usePlayFoldersQuery({ enabled: true })

  const allPlayFolder: PlayFolder = { id: 'all', name: 'All plays', description: 'All folders' }
  const defaultFolder: PlayFolder = { id: 'default', name: 'Default', description: 'Default folder' }

  const onClose = useCallback(() => {
    $playFolderSelectModalIsOpen.set(false)
  }, [])

  const onEdit = useCallback(( folder: Syncable<PlayFolder>, event: any) => {
    event.stopPropagation()
    onClose()
    $playFolderModalIsOpen.set({
      isOpen: true,
      folder
    })
  }, [onClose])

  useEffect(() => {
    setCurrentFolders([allPlayFolder, defaultFolder, ...foldersStore])
  }, [foldersStore]);

  useEffect(() => {
    setFoldersLoading(true)
    const loadFolders = async () => {
      await getFolders()
      setFoldersLoading(false)
    }
    void loadFolders()
  }, []);

  const isLoading = useMemo(() => {
    return foldersIsLoadingStore || isFoldersLoading
  }, [foldersIsLoadingStore, isFoldersLoading])

  return (
    <Modal
      open={true}
      centered={true}
      closable={true}
      closeIcon={<div style={{ color: yellow}}><XMarkIcon style={{ width: '34px'}} /></div>}
      onCancel={onClose}
      footer={null}
      styles={{
        header: {
          background: lighterBlueBackground,
          fontSize: '30px !important',
          color: '#fff'
        },
        content: {
          background: lighterBlueBackground,
          color: '#fff'
        }
      }}
    >
      <div>
        <div>
          <h2 style={{ color: '#fff', textAlign: 'center', marginBottom: '20px' }}>Select folder</h2>
        </div>
        <div>
          {isLoading && <div>Loading folders...</div>}
          {currentFolders.length > 0 && currentFolders.map(folder => (
            <div
              onClick={() => {
                onSelect(folder)
                onClose()
              }}
              key={folder.id} style={{ userSelect: 'none', marginBottom: '5px', cursor: 'pointer', minHeight: '55px', paddingBottom: '5px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '1.1rem', textTransform: 'uppercase', borderBottom: '1px solid rgba(255,255,255,0.3)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {folder.id === 'all' ? <QueueListIcon style={{ width: '24px', color: yellow }} /> : (
                  <FolderIcon style={{ width: '24px', color: yellow }} />
                )}
                <span style={{ fontWeight: 'bold' }}>{folder.name}</span>
              </div>
              {folder.id !== 'default' && folder.id !== 'all' && !onlySelect && (
                <Button  secondary={true} onClick={(e) => onEdit(folder, e)}>Edit</Button>
              )}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}